import { IColumnHookInput, IColumnHookOutput } from 'dromo-uploader-react'
import { ITableMessage } from 'dromo-uploader-js'

export function parseDateValues(
  values: IColumnHookInput[],
  fullDate: boolean
): IColumnHookOutput[] {
  return values.map((row) => {
    // empty
    if (!row.value) {
      return row
    }
    const timeStamp = Date.parse(String(row.value))
    // cannot be parsed as a date
    if (isNaN(timeStamp)) {
      return {
        index: row.index,
        value: null,
        info: [
          {
            message: `Could not parse "${row.value}" as a date`,
            level: 'info',
          },
        ],
      }
    }

    const date = new Date(timeStamp)
    const newValue = fullDate
      ? date.toLocaleDateString('en-US', { timeZone: 'UTC' })
      : date.getUTCFullYear()

    return {
      index: row.index,
      value: newValue,
    }
  })
}

export function validateDate(value: string): ITableMessage[] {
  if (!value) {
    return []
  }
  const date = new Date(value)
  if (date.getUTCFullYear() < 1800 || date.getFullYear() >= 2100) {
    return [
      { message: 'Must be between 01/01/1800 and 01/01/2100', level: 'error' },
    ]
  }
  return []
}
